<template>
  <div class="tenant-info-wrapper" v-if="proposal">
    <TenantValid v-if="isProposalValid" :proposal="proposal" class="tenant-info-box" />
    <TenantExpired v-else class="tenant-info-box" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import TenantExpired from '../components/TenantExpired.vue';
import TenantValid from '../components/TenantValid.vue';

export default {
  name: 'tenantInfo',
  components: {
    TenantExpired,
    TenantValid,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('tenant', ['proposal']),
    isProposalValid() {
      const isExpired = !(this.proposal
        && moment(this.proposal.expireAt).isSameOrBefore(Date.now()));
      const hasTransaction = !!this.proposal.transaction;
      return isExpired || hasTransaction;
    },
  },
  methods: {
    ...mapActions('tenant', ['getProposal']),
    ...mapActions('auth', ['setToken']),
  },
  async created() {
    const { proposal, token } = this.$route.query;
    await this.setToken({ token });
    await this.getProposal({ proposal });
  },
};
</script>

<style lang="scss" scoped>
  .tenant-info-wrapper {
    background-color: var(--gray-100);
  }

  .tenant-info-box {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-width: 608px;
    margin: 0 auto;
    padding: 24px;
    height: 100vh;
    background-color: var(--white);
  }
</style>
